import { useMutation, useQueryClient } from 'react-query'

export const useResetChallenge = () => {
  const client = useQueryClient()
  return useMutation(() => Promise.resolve(client.setQueryData(['mfa'], null)))
}
